var $b7df24bc7ad029ba$exports = {};
$b7df24bc7ad029ba$exports = {
    "loading": `Carregando...`,
    "loadingMore": `Carregando mais...`
};


export {$b7df24bc7ad029ba$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
